import { Controller } from "stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {

  initialize() {
    // Auto-scroll is opt-in per card via the `autoScroll` schema field.
    const autoScroll = this.element.dataset.autoScroll === 'true';

    this.slider = new Splide(this.element, {
      type: 'loop',
      perPage: 1,
      pagination: false,
      arrows: true,
      speed: 600,
      waitForTransition: false,
      autoplay: autoScroll,
      interval: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
    }).mount();

    document.dispatchEvent(new CustomEvent('NewSplideInstance', { detail: { 'splideElement': this.element } }));
  }
};
